import { render, staticRenderFns } from "./ApplicantsBoard.vue?vue&type=template&id=ffa3e5f2&scoped=true"
import script from "./ApplicantsBoard.vue?vue&type=script&lang=js"
export * from "./ApplicantsBoard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa3e5f2",
  null
  
)

export default component.exports